<template>
    <!-- <svg :class="svgClass" aria-hidden="true">
      <use :xlink:href="iconName" />
  </svg> -->
    <span :class="['iconfont-v4', iconName, className]" />
</template>

<script>
export default {
    name: 'SvgIcon',
    props: {
        icon: {
            type: String,
            required: true,
        },
        className: {
            type: String,
        },
    },
    computed: {
        iconName() {
            if (this.icon) {
                return this.icon.indexOf('icon') === 0 ? this.icon : (this.icon.match('icon-') ? `${this.icon}` : `icon-${this.icon}`);
            }
            return '';
        },
        svgClass() {
            if (this.className) {
                return `svg-icon ${this.className}`;
            }
            return 'svg-icon';
        },
    },
};
</script>
